import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import MembershipHero from './components/MembershipHero';
import MembershipTiers from './components/MembershipTiers';
import NADMembershipTiers from './components/NADMembershipTiers';
import MembershipBenefits from './components/MembershipBenefits';
import MembershipSignupForm from './components/MembershipSignupForm';

export default function MembershipPage() {
  const [activeTab, setActiveTab] = useState<'specialty' | 'nad'>('specialty');

  return (
    <div className="min-h-screen bg-sand">
      <Navigation />
      <MembershipHero />
      
      {/* Tab Switcher */}
      <div className="py-12 px-6 bg-sand">
        <div className="max-w-md mx-auto bg-bone rounded-full p-1 flex items-center">
          <button
            onClick={() => setActiveTab('specialty')}
            className={`flex-1 py-3 px-6 text-sm font-light tracking-wide rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeTab === 'specialty'
                ? 'bg-charcoal text-white'
                : 'text-greige hover:text-charcoal'
            }`}
          >
            Specialty Memberships
          </button>
          <button
            onClick={() => setActiveTab('nad')}
            className={`flex-1 py-3 px-6 text-sm font-light tracking-wide rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeTab === 'nad'
                ? 'bg-charcoal text-white'
                : 'text-greige hover:text-charcoal'
            }`}
          >
            NAD Drip Memberships
          </button>
        </div>
      </div>

      {/* Conditional Rendering */}
      {activeTab === 'specialty' ? <MembershipTiers /> : <NADMembershipTiers />}
      
      <MembershipSignupForm />
      <MembershipBenefits />
      <Footer />
    </div>
  );
}